import { render, staticRenderFns } from "./follower.vue?vue&type=template&id=6c1bbd28&scoped=true"
import script from "./follower.vue?vue&type=script&lang=js"
export * from "./follower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bbd28",
  null
  
)

export default component.exports